import { useNavigate, useLocation } from 'react-router-dom';
import useAppSelector from 'hooks/useAppSelector';
import { AppBar, Box, Avatar } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AvatarIcon from '@mui/material/Avatar';
import { ReactComponent as Logo } from 'assets/logos/topbar.svg';
import { useStyles } from './styles';

interface NavBarProps {
  backRoute?: string;
  hasAvatar?: boolean;
}

function NavBar({ backRoute, hasAvatar }: NavBarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const styles = useStyles();

  const { user } = useAppSelector((state) => state.auth);

  const avatarUrl = `${process.env.REACT_APP_MEDIA_URL}/users/${user?.id}/avatar-small.png`;

  const avatar = () =>
    user?.hasAvatar ? (
      <Avatar className={styles.avatarIcon} src={avatarUrl} />
    ) : (
      <AvatarIcon className={styles.avatarIcon} />
    );

  return (
    <AppBar position="static" style={{ boxShadow: 'none' }}>
      <Box className={styles.container}>
        {!!backRoute && (
          <ArrowBackIcon
            className={styles.backIcon}
            onClick={() => navigate(`${backRoute}${location.search}`)}
          />
        )}
        <Logo className={styles.logo} />
        {hasAvatar && avatar()}
      </Box>
    </AppBar>
  );
}

export default NavBar;
